export default __webpack_public_path__ + "media/src/assets/images/okta-c575dcdb1ab43f5ada2e4a23d8f6e992.svg";